import Vue from "vue";

function initialState() {
  return {
    GroupWizardInfo: {},
    AllAvailableRoles: [],
    PreviousTab: {},
    CurrentTab: {},
    AllAvailableUsers: [],
    GroupActionType: "",
    GroupAvatarInfo: {}
  };
}

const state = initialState();

const actions = {
  GetGroupWizardDetailsForId: function(context, groupId) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("/core/groups/groupwizard/" + groupId)
        .then(function(data) {
          context.commit("UpdateGroupWizardInfo", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetActivePandoRoles: function(context, param) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get("rolePermissions/GetAllRoles/1")
        .then(function(data) {
          context.commit("UpdateAllRoles", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  SaveGroupWizardInfo: function(context, groupData) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/core/groups/saveGroupWizard", groupData)
        .then(function(data) {
          //context.commit('UpdateGroupAvatarInfo', {});
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  GetAllUsers: function(context, storeGroupPlatform) {
    var url = "";
    if (storeGroupPlatform > 0)
      url = "core/platforms/" + storeGroupPlatform + "/users/status/1";
    else url = "core/users/status/1";

    return new Promise((resolve, reject) => {
      Vue.http
        .get(url)
        .then(function(data) {
          context.commit("UpdateAvailableUsers", data.data.Data);
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  uploadGroupAvatarImage: function(context, fileInfo) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/core/groups/" + fileInfo.GroupId + "/avatar", fileInfo.FileInfo)
        .then(function(data) {
          // console.log("Rte call ", data);
          //context.commit('UpdateGroupAvatarInfo', {});
          resolve(data.data.Data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  UpdateGroupDetailsInfo: function(context, data) {
    context.commit("UpdateGroupDetailsInfo", data);
  },
  UpdateGroupMembersInfo: function(context, data) {
    context.commit("UpdateGroupMembersInfo", data);
  },
  UpdateGroupRolesInfo: function(context, data) {
    context.commit("UpdateGroupRolesInfo", data);
  }
};

const mutations = {
  UpdateGroupWizardInfo: function(state, data) {
    state.GroupWizardInfo = data;
  },
  UpdateGroupTabs: function(state, data) {
    if (state.PreviousTab.StepId == 1) {
      state.GroupWizardInfo.GroupDetails = data;
    }
    if (state.PreviousTab.StepId == 2) {
      state.GroupWizardInfo.GroupMembers = data;
    }
    if (state.PreviousTab.StepId == 3) {
      state.GroupWizardInfo.GroupRoles = data;
    }
  },

  UpdateAllRoles: function(state, data) {
    if (data) data = data.filter(x => !x.IsAlertMiner);

    state.AllAvailableRoles = data;
  },
  UpdateCurrentTab: function(state, data) {
    state.CurrentTab = data;
  },
  UpdatePreviousTab: function(state, data) {
    state.PreviousTab = data;
  },
  UpdateAvailableUsers: function(state, data) {
    state.AllAvailableUsers = data;
  },
  UpdateGroupDetailsInfo: function(state, data) {
    state.GroupWizardInfo.GroupDetails = data;
  },
  UpdateGroupMembersInfo: function(state, data) {
    state.GroupWizardInfo.GroupMembers = data;
  },
  UpdateGroupRolesInfo: function(state, data) {
    state.GroupWizardInfo.GroupRoles = data;
  },
  UpdateGroupActionType: function(state, data) {
    state.GroupActionType = data;
  },
  UpdateGroupAvatarInfo: function(state, data) {
    state.GroupAvatarInfo = data;
  }
};

const getters = {
  GroupWizardInfo: function() {
    return state.GroupWizardInfo;
  },
  AllAvailableRoles: function() {
    return state.AllAvailableRoles;
  },
  CurrentTab: function() {
    return state.CurrentTab;
  },
  PreviousTab: function() {
    return state.PreviousTab;
  },
  AllAvailableUsers: function() {
    return state.AllAvailableUsers;
  },
  GroupActionType: function() {
    return state.GroupActionType;
  },
  GroupAvatarInfo: function() {
    return state.GroupAvatarInfo;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/GroupWizard.js